import {
    FeedbacksTableData,
    FeedbacksTableFiltersApi,
} from '@/components/feedbacks-table/feedbacks-table-columns.types';
import { ClearFilterButton, SearchIcon } from '@/components/feedbacks-table/feedbacks-table-columns.filters.shared';
import Select from '@/ui/Select';
import clsx from 'clsx';

export const renderGroupFilterByColumn = (columnKey: keyof FeedbacksTableData, filters: FeedbacksTableFiltersApi) => {
    const {
        productGroupId,
        brandGroupId,
        productSearch,
        brandSearch,
        preparedProductGroups,
        preparedBrands,
        setProductGroupId,
        setBrandGroupId,
        setProductSearch,
        setBrandSearch,
    } = filters;

    switch (columnKey) {
        case 'product:name':
            return (
                <div className="flex h-[34px] w-[90px] min-w-0 items-center gap-1 md:w-[147px] lg:w-[260px]">
                    <div className="relative h-[34px] min-w-0 flex-1">
                        <Select
                            id="reviews-table-filter-product-group"
                            ariaLabel="Фильтр группы продукта"
                            options={preparedProductGroups}
                            placeholder="Группа"
                            className={clsx(
                                'h-[34px] min-w-0 w-full [&>button]:h-[34px] [&>button]:min-h-[34px] [&>button]:pr-8 [&>button>input]:pr-6 [&>button>input]:text-slate-900',
                                productGroupId
                                    ? '[&>button>input]:placeholder:text-slate-900'
                                    : '[&>button>input]:placeholder:text-slate-400',
                            )}
                            value={productGroupId}
                            onChange={setProductGroupId}
                            withInput
                            searchString={productSearch}
                            setSearchString={setProductSearch}
                            uiSize="compact"
                        />
                        <div className="pointer-events-none absolute inset-y-0 right-2 flex items-center">
                            <SearchIcon />
                        </div>
                    </div>
                    {productGroupId && (
                        <ClearFilterButton
                            ariaLabel="Очистить фильтр группы продуктов"
                            onClick={() => {
                                setProductGroupId(undefined);
                                setProductSearch(undefined);
                            }}
                        />
                    )}
                </div>
            );
        case 'product:brandName':
            return (
                <div className="flex h-[34px] w-[110px] min-w-0 items-center gap-1 md:w-[140px]">
                    <Select
                        id="reviews-table-filter-brand-group"
                        ariaLabel="Фильтр бренда"
                        options={preparedBrands}
                        placeholder="Фильтр"
                        className={clsx(
                            'h-[34px] min-w-0 flex-1 [&>button]:h-[34px] [&>button]:min-h-[34px] [&>button>input]:text-slate-900',
                            brandGroupId
                                ? '[&>button>input]:placeholder:text-slate-900'
                                : '[&>button>input]:placeholder:text-slate-400',
                        )}
                        value={brandGroupId}
                        onChange={setBrandGroupId}
                        withInput
                        searchString={brandSearch}
                        setSearchString={setBrandSearch}
                        uiSize="compact"
                    />
                    {brandGroupId && (
                        <ClearFilterButton
                            ariaLabel="Очистить фильтр бренда"
                            onClick={() => {
                                setBrandGroupId(undefined);
                                setBrandSearch(undefined);
                            }}
                        />
                    )}
                </div>
            );
        default:
            return null;
    }
};
